import { Component, ElementRef, Input, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, Renderer2, OnDestroy } from '@angular/core';

import { ApiError, AuthService, ConfigService, DataTablesService, MessageService, VisualizacaoStorageService } from '../../../../../core';
import { ConfigAnaliseMercado } from '../../../../configuracoes/app/analise-mercado';
import { DecimalFormatPipe, TablePercProgressComponent } from '../../../../../shared';
import { isLancamentoQuantidade, isLancamentoPeso, isLancamentoValor } from '../../../../../models';
import { ClienteAnaliseMercadoStatusProjetadoBadgePillComponent } from '../../../status-projetado';
import { perspectivaClassificacao, perspectivaMeta, perspectivaProjetada } from '../../cliente-analise-mercado-perspectiva';
import { ClienteAnaliseMercadoProjecaoSave, ClienteAnaliseMercadoProjecaoClassificacaoSave, ClienteAnaliseMercadoProjecaoHttpService } from '../../../projecao';
import { ClienteAnaliseMercadoFilter } from '../../../adapters';
import { ClienteAnaliseMercadoClassificacaoSearch, ClienteAnaliseMercadoClassificacaoSearchTotal, ClienteAnaliseMercadoClassificacaoSearchOrderBy, ClienteAnaliseMercadoClassificacaoHttpService, ClienteAnaliseMercadoClassificacaoAuthGuardService } from '../../../classificacao';
import { ClienteAnaliseMercadoLancamentoHttpService } from '../../../lancamento';
import { ClienteAnaliseMercadoLancamentoFormModalComponent } from '../../../lancamento';
import { calcularQuantidadeProjetadaPerc, calcularPesoProjetadoPerc, calcularValorProjetado, calcularValorProjetadoPerc } from '../../../calculo/projetado';
import { calcularQuantidadeRealizadaPerc, calcularPesoRealizadoPerc, calcularValorRealizadoPerc } from '../../../calculo/realizado';
import { Meta, MetaTotal, MetaCalculoService } from '../../../../meta';
import { pessoaCentralCompras } from '../../../../pessoa/tipo';
import { ClienteAuthGuardService } from '../../../../pessoa/cliente/services';
import { ClienteNomePipe, ClienteNomeSecundarioPipe } from '../../../../pessoa/cliente/pipes';
import { ClienteFormModalComponent } from '../../../../pessoa/cliente/form-modal';
import { ClienteCentralCompraParticipante, ClienteCentralCompraFormModalComponent, ClienteCentralCompraParticipanteFormInsertModalComponent, ClienteCentralCompraAuthGuardService } from '../../../../pessoa/cliente/central-compra';
import { ClienteCarteiraPreBaixarModalComponent } from '../../../../cliente-carteira/prebaixar';
import { ClienteCarteiraBaixarModalComponent } from '../../../../cliente-carteira/baixar';
import { RepresentanteNomePipe, RepresentanteNomeSecundarioPipe } from '../../../../pessoa/representante';
import Inputmask from 'inputmask';
import { ClienteAnaliseMercadoOptions } from '../../../cliente-analise-mercado-options';
import { GrupoClassificacao } from 'app/home/grupo-classificacao';

@Component({
    selector: 'sgt-cliente-analise-mercado-perspectiva-projetada-list',
    templateUrl: './cliente-analise-mercado-perspectiva-projetada-list.component.html',
    styleUrls: ['./cliente-analise-mercado-perspectiva-projetada-list.component.less']
})
export class ClienteAnaliseMercadoPerspectivaProjetadaListComponent implements OnInit, OnDestroy {
    configAnaliseMercado: ConfigAnaliseMercado;
    isAdministrador: boolean;
    isAtendente: boolean;
    isRepresentante: boolean;
    isFinanceiro: boolean;

    /** Se são o mês e ano atuais */
    @Input() isMesAtual: boolean;
    @Input() filter: ClienteAnaliseMercadoFilter;

    /** Se o lançamento projetado é controlado por quantidade */
    @Input() controleQuantidade: boolean;
    /** Se o lançamento projetado é controlado por peso */
    @Input() controlePeso: boolean;
    /** Se o lançamento projetado é controlado por valor */
    @Input() controleValor: boolean;

    @Input() grupoClassificacao: GrupoClassificacao = null;

    /** Se é a projeção pela perspectiva da meta */
    @Input() isPerspectivaMeta = false;
    /** Meta a serem projetados os lançamentos */
    @Input() meta: Meta = null;
    /** Totais da meta a serem projetados os lançamentos */
    @Input () metaTotais: MetaTotal = null;
    /** Percentual da quantidade projetada da meta dos representantes */
    quantidadeMetaRepresentantesPercProjetada = 0;
    /** Percentual do peso projetado da meta dos representantes */
    pesoMetaRepresentantesPercProjetado = 0;
    /** Percentual do valor projetado da meta dos representantes */
    valorMetaRepresentantesPercProjetado = 0;

    // Entities
    idDataTable = 'clienteAnaliseMercadoPerspectivaProjetadaListTable';
    private dataTable: any;
    visualizacaoStorageKey = 'clienteAnaliseMercadoPerspectivaProjetadaListVisualizacao';
    isLoading: boolean;
    // Total
    isLoadingTotal: boolean;
    total: ClienteAnaliseMercadoClassificacaoSearchTotal;

    isSaving = false;
    isSaved = false;
    lastSaveAt: Date;

    @ViewChild('lancamentoFormModal') lancamentoFormModal: ClienteAnaliseMercadoLancamentoFormModalComponent;
    @ViewChild('clienteFormModal') clienteFormModal: ClienteFormModalComponent;
    @ViewChild('centralCompraFormModal') centralCompraFormModal: ClienteCentralCompraFormModalComponent;
    @ViewChild('centralCompraParticipanteFormModal') centralCompraParticipanteFormModal: ClienteCentralCompraParticipanteFormInsertModalComponent;
    @ViewChild('clienteCarteiraPreBaixarModal') clienteCarteiraPreBaixarModal: ClienteCarteiraPreBaixarModalComponent;
    @ViewChild('clienteCarteiraBaixarModal') clienteCarteiraBaixarModal: ClienteCarteiraBaixarModalComponent;
    /** Container para criar dinamicamente o badge pill do status projetado */
    @ViewChild('statusProjetadoBadgePillContainer', {read: ViewContainerRef}) statusProjetadoBadgePillContainer: ViewContainerRef;
    /** Container para criar dinamicamente os progress dos percentuais na table */
    @ViewChild('tablePercProgressContainer', {read: ViewContainerRef}) tablePercProgressContainer: ViewContainerRef;

    constructor(private el: ElementRef,
                private componentFactoryResolver: ComponentFactoryResolver,
                private renderer: Renderer2,
                private authService: AuthService,
                private configService: ConfigService,
                private dataTablesService: DataTablesService,
                private messageService: MessageService,
                private visualizacaoStorageService: VisualizacaoStorageService,
                private decimalFormatPipe: DecimalFormatPipe,
                private clienteAuthGuardService: ClienteAuthGuardService,
                private clienteNomePipe: ClienteNomePipe,
                private clienteNomeSecundarioPipe: ClienteNomeSecundarioPipe,
                private representanteNomePipe: RepresentanteNomePipe,
                private representanteNomeSecundarioPipe: RepresentanteNomeSecundarioPipe,
                private clienteAnaliseMercadoClassificacaoHttpService: ClienteAnaliseMercadoClassificacaoHttpService,
                private clienteAnaliseMercadoClassificacaoAuthGuardService: ClienteAnaliseMercadoClassificacaoAuthGuardService,
                private clienteAnaliseMercadoProjecaoHttpService: ClienteAnaliseMercadoProjecaoHttpService,
                private clienteCentralCompraAuthGuardService: ClienteCentralCompraAuthGuardService,
                private metaCalculoService: MetaCalculoService,
                private clienteAnaliseMercadoLancamentoHttpService: ClienteAnaliseMercadoLancamentoHttpService) { }

    ngOnInit() {
        this.configAnaliseMercado = this.configService.getAnaliseMercado();
        this.isAdministrador = this.authService.isAdministrador();
        this.isAtendente = this.authService.isAtendente();
        this.isRepresentante = this.authService.isRepresentante();
        this.isFinanceiro = this.authService.isFinanceiro();
    }

    search() {
        // Obtendo os totais de clientes
        this.getTotais()
            .then(() => {
                if (!this.dataTable) { // Table ainda não criada
                    // Obtendo os dados da datatable armazenados no storage para sabermos o order e posição do scroll
                    const vs = this.visualizacaoStorageService.get(this.visualizacaoStorageKey);

                    this.createTable(vs?.order)
                        .then(() => {
                            // Realizando scroll para a posição inicial salva
                            if (vs?.scrollerStartPosition > this.dataTable?.scroller?.page()?.end) {
                                this.dataTable?.scroller?.toPosition(vs?.scrollerStartPosition);
                            }
                        });
                } else { // Table já criada, somente damos um reload
                    this.dataTable.ajax.reload();
                }
            })
            .catch(() => {});
    }

    /** Obtem os totais das análises de mercados dos clientes */
    private getTotais(): Promise<ClienteAnaliseMercadoClassificacaoSearchTotal> {
        return new Promise<ClienteAnaliseMercadoClassificacaoSearchTotal>((resolve, reject) => {
            this.clienteAnaliseMercadoClassificacaoHttpService.getSearchTotais(this.filter)
                .subscribe(
                    total => {
                        this.total = total;
                        this.isLoadingTotal = false;

                        // Calculando os percentuais projetados sobre as metas dos representantes
                        if (this.isPerspectivaMeta) {
                            this.calcularMetaPercProjetados();
                        }

                        resolve(total);
                    },
                    (error: ApiError) => {
                        this.isLoadingTotal = false;
                        this.messageService.error(error.message, 'Erro ao obter os totais dos clientes', error);
                        reject();
                    }
                );

        })
    }

    /** Atualiza a dataTable e os totais da pesquisa */
    refresh() {
        // Atualiza a dataTable
        this.dataTable?.draw('page');
        // Atualiza os totais
        this.getTotais()
            .then(() => {})
            .catch(() => {});
    }

    /** Cria a dataTable com pesquisa das análises de mercados dos clientes */
    private createTable(initOrder: any[] = null): Promise<void> {
        return new Promise<void>((resolve) => {
            // const columns: DataTablesColumnSettings[] = [
            const columns: any[] = [
                {
                    data: null,
                    className: 'col-options text-center',
                    render: (entity: ClienteAnaliseMercadoClassificacaoSearch) => this.createDropdownOptions(entity),
                    createdCell: (td, cellData) => {
                        const entity = cellData as ClienteAnaliseMercadoClassificacaoSearch;
                        this.bindEventsDropdownOptions(entity, td);
                    }
                },
                /*{
                    data: null,
                    className: 'col-status text-center',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.StatusProjetado,
                    createdCell: (td: any, cellData: any, entity: ClienteAnaliseMercadoClassificacaoSearch) => {
                        this.createStatusProjetadoBadgePill(td, entity);
                    },
                    render: () => {
                        return '';
                    }
                },*/
                {
                    data: null,
                    className: 'col-nome-cliente',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.NomeCliente,
                    render: (data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        if (data) {
                            return `
                                <span>${this.clienteNomePipe.transform(data.nomeCliente, data.nomeFantasiaCliente, data.codigoIntegracaoErpCliente, data.tipoPessoa)}</span>
                                <br/>
                                <small>${this.clienteNomeSecundarioPipe.transform(data.nomeCliente, data.nomeFantasiaCliente)}</small>
                            `;
                        }
                        return '';
                    },
                    createdCell: (td: any, cellData: any, data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        if (data) {
                            td.title = this.clienteNomePipe.transform(data.nomeCliente, data.nomeFantasiaCliente, data.codigoIntegracaoErpCliente, data.tipoPessoa);
                        }
                    }
                },
                {
                    data: null,
                    className: 'col-nome-representante',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.NomeRepresentante,
                    render: (data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        if (data) {
                            return `
                                    <span>${this.representanteNomePipe.transform(data.nomeRepresentante, data.nomeFantasiaRepresentante)}</span>
                                    <br/>
                                    <small>${this.representanteNomeSecundarioPipe.transform(data.nomeRepresentante, data.nomeFantasiaRepresentante)}</small>
                                `;
                        }
                        return '';
                    },
                    createdCell: (td: any, cellData: any, data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        if (data) {
                            td.title = this.representanteNomePipe.transform(data.nomeRepresentante, data.nomeFantasiaRepresentante, data.codigoIntegracaoErpRepresentante);
                        }
                    }
                },
                {
                    data: null,
                    className: 'col-classificacoes-nome',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.ClassificacoesNome,
                    render: (entity: ClienteAnaliseMercadoClassificacaoSearch) => {
                        if (entity?.classificacoesNome) {
                            return entity.classificacoesNome;
                        } else if (this.isPerspectivaMeta) {
                            return this.meta.classificacoesNome;
                        } else if (this.grupoClassificacao?.classificacoesNome) {
                            return this.grupoClassificacao.classificacoesNome;
                        }

                        return`<i class="fas fa-exclamation-triangle"></i> Não Informada`
                    },
                    createdCell: (td, entity: ClienteAnaliseMercadoClassificacaoSearch) => {
                        if (entity?.classificacoesNome) {
                            td.title = entity?.classificacoesNome;
                        } else if (this.isPerspectivaMeta) { // Perspectiva Meta
                                td.title = this.meta.classificacoesNome;
                        } else if (this.grupoClassificacao?.classificacoesNome) {
                            td.title = this.grupoClassificacao.classificacoesNome;
                        } else { // Perspectiva Projetada
                                td.title = 'Segmento não informado';
                                jQuery(td)?.addClass('nao-informada');
                        }
                    }
                },
                /*{
                    data: null,
                    className: 'col-cadastro-situacao text-center',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.CadastroESituacaoCliente,
                    render: (data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        if (!data) {
                            return null;
                        }
                        let template = '';
                        // Cadastro
                        template += `<span class="${this.clienteCadastroBadgePipe.transform(data.cadastro)} mr-1">${this.clienteCadastroPipe.transform(data.cadastro)}</span>`;
                        // Situação
                        template += `<span class="${this.clienteSituacaoBadgePipe.transform(data.situacao)}">${this.clienteSituacaoPipe.transform(data.situacao)}</span>`;

                        return template;
                    }
                },*/
                /*{
                    data: 'nomeClienteTipo',
                    className: 'col-nome-cliente-tipo',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.NomeClienteTipo,
                    createdCell: (td, cellData) => td.title = cellData ? cellData : ''
                },*/
                /*{
                    data: 'nomeItemTipo',
                    className: 'col-nome-item-tipo',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.NomeItemTipo,
                    createdCell: (td, cellData) => td.title = cellData ? cellData : ''
                },*/

                /** Quantidade **/

                // Quantidade Pretendida
                {
                    data: 'quantidadePretendida',
                    className: 'col-quantidade col-quantidade-pretendida text-right',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.QuantidadePretendida,
                    render: (data: number) => this.decimalFormatPipe.transform(data, 1, 0, 0)
                },
                // Valor Unitário
                {
                    data: null,
                    className: 'col-quantidade col-quantidade-projetada-valor-unitario text-right',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.QuantidadeProjetadaValorUnitario,
                    render: (data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        if (this.solicitarPrecoMedioQuantidade(data)) {
                            return `<input type="text" class="form-control text-right" id="${this.createIdInputQuantidadeValorUnitarioProjetado(data.idAnaliseClassificacao)}">`
                        } else if (this.isLancamentoQuantidade(data.lancamentoAnaliseClassificacao)) {
                            return this.decimalFormatPipe.transform(data.quantidadeProjetadaValorUnitario, 1, 2, 2);
                        }
                        return '';
                    },
                    createdCell: (td, entity: ClienteAnaliseMercadoClassificacaoSearch, rowData: any, rowIndex: number) => {
                        const myself = this;

                        // Somente cria o input de edição quando solicitar para ser informado
                        if (!this.solicitarPrecoMedioQuantidade(entity)) {
                            return;
                        }

                        // Obtendo o input para a edição
                        const input = jQuery(td).find('input');
                        const inputElement = input[0] as any;

                        // Adicionando um numeric mask ao input para formatar a quantidade digitada
                        const inputMask = new Inputmask({
                                alias: 'decimal',
                                numericInput: true,
                                unmaskAsNumber: true,
                                digits: 2,
                                groupSeparator: '.',
                                radixPoint: ',',
                                allowMinus: false,
                                placeholder: '',
                                showMaskOnFocus: false,
                                showMaskOnHover: false,
                                undoOnEscape: false
                        }).mask(inputElement);
                        // Setando o valor unitário projetado no input
                        inputElement.value = (entity?.quantidadeProjetadaValorUnitario !== undefined && entity?.quantidadeProjetadaValorUnitario !== null) ? entity?.quantidadeProjetadaValorUnitario : '';

                        // Ao realizar alterações no input
                        input.on('change', function() {
                            // Obtendo o valor unitário projetado no input
                            const unmaskedvalue = inputMask?.unmaskedvalue();
                            // Setando o valor unitário projetado
                            entity.quantidadeProjetadaValorUnitario = (!unmaskedvalue || unmaskedvalue === '') ? null : Number(unmaskedvalue);
                            // Calculando o valor projetado
                            const valorProjetado = calcularValorProjetado(entity.quantidadeProjetada, entity.quantidadeProjetadaValorUnitario);
                            // Atualizando o valor projetado
                            myself.changeValorProjetado(entity, valorProjetado, td);
                            // Atualizando a projeção no server
                            myself.saveProjecao(entity, td);
                        }).on('focus', () => {
                            jQuery(`#${this.idDataTable}`).find('tbody tr').removeClass('active');
                            jQuery(td)?.parent()?.addClass('active');
                        });
                    }
                },
                // Quantidade Projetada
                {
                    data: null,
                    className: 'col-quantidade col-quantidade-projetada text-right',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.QuantidadeProjetada,
                    render: (data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        let template = '';
                        if (this.canSaveProjecaoQuantidade(data)) {
                            template +=  `<input type="text" class="form-control text-right" id="${this.createIdInputQuantidadeProjetada(data.idAnaliseClassificacao)}">`
                        } else if (this.isLancamentoQuantidade(data.lancamentoAnaliseClassificacao)) {
                            template += `
                                <span class="container-value">
                                    ${this.decimalFormatPipe.transform(data?.quantidadeProjetada ? data?.quantidadeProjetada : null, 1, 0, 0)}
                                </span>
                            `;
                        }

                        return template;
                    },
                    createdCell: (td, entity: ClienteAnaliseMercadoClassificacaoSearch) => {
                        const myself = this;

                        // Somente cria o input de edição quando puder salvar a projeção por quantidade
                        if (!this.canSaveProjecaoQuantidade(entity)) {
                            return;
                        }

                        // Obtendo o input para a edição
                        const input = jQuery(td).find('input');
                        const inputElement = input[0] as any;

                        // Adicionando um numeric mask ao input para formatar a quantidade digitada
                        const inputMask = new Inputmask({
                                alias: 'decimal',
                                numericInput: true,
                                unmaskAsNumber: true,
                                digits: 0,
                                groupSeparator: '.',
                                radixPoint: ',',
                                allowMinus: false,
                                placeholder: '',
                                showMaskOnFocus: false,
                                showMaskOnHover: false,
                                undoOnEscape: false
                        }).mask(inputElement);
                        // Setando o valor projetado no input
                        inputElement.value = (entity?.quantidadeProjetada !== undefined && entity?.quantidadeProjetada !== null) ? entity?.quantidadeProjetada : '';

                        // Ao realizar alterações no input
                        input.on('change', function() {
                            // Obtendo a quantidade projetada no input
                            const unmaskedvalue = inputMask?.unmaskedvalue();
                            const quantidadeProjetada = (!unmaskedvalue || unmaskedvalue === '') ? null : Number(unmaskedvalue);
                            // Atualizando a quantidade projetada
                            myself.changeQuantidadeProjetada(entity, quantidadeProjetada, td);
                            // Atualizando a quantidade projetada no server
                            myself.saveProjecao(entity, td);
                        }).on('focus', () => {
                            jQuery(`#${this.idDataTable}`).find('tbody tr').removeClass('active');
                            jQuery(td)?.parent()?.addClass('active');
                        });

                        // Progress
                        /*if (this.configAnaliseMercado?.solicitarPotencial) {
                            entity.quantidadeProjetadaPercProgress = this.createTablePercProgress(entity?.quantidadeProjetadaPerc, td);
                        }*/
                    }
                },
                // Quantidade Realizada
                {
                    data: null,
                    className: 'col-quantidade col-quantidade-realizada text-right',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.QuantidadeRealizada,
                    /*createdCell: (td: any, cellData: any, entity: ClienteAnaliseMercadoClassificacaoSearch) => {
                        // Progress
                        if (this.isLancamentoQuantidade(entity.lancamentoAnaliseClassificacao)) {
                            entity.quantidadeRealizadaPercProjetadaProgress = this.createTablePercProgress(entity.quantidadeRealizadaPercProjetada, td);
                        }
                    },*/
                    render: (data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        if (!data) {
                            return;
                        }

                        return `
                            <span class="container-value">
                                ${this.decimalFormatPipe.transform(data.quantidadeRealizada, 1, 0, 0)}
                            </span>
                        `;
                    }
                },


                /** Peso **/

                // Peso Pretendido
                {
                    data: 'pesoPretendido',
                    className: 'col-peso col-peso-pretendido text-right',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.PesoPretendido,
                    render: (data: number) => this.decimalFormatPipe.transform(data, 1, 0, 0)
                },
                // Valor Unitário
                {
                    data: null,
                    className: 'col-peso col-peso-projetado-valor-unitario text-right',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.PesoProjetadoValorUnitario,
                    render: (data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        if (this.solicitarPrecoMedioPeso(data)) {
                            return `<input type="text" class="form-control text-right" id="${this.createIdInputPesoValorUnitarioProjetado(data.idAnaliseClassificacao)}">`
                        } else if (this.isLancamentoPeso(data.lancamentoAnaliseClassificacao)) {
                            return this.decimalFormatPipe.transform(data.pesoProjetadoValorUnitario, 1, 2, 2);
                        }
                        return '';
                    },
                    createdCell: (td, entity: ClienteAnaliseMercadoClassificacaoSearch, rowData: any, rowIndex: number) => {
                        const myself = this;

                        // Somente cria o input de edição quando for solicitado para ser informado
                        if (!this.solicitarPrecoMedioPeso(entity)) {
                            return;
                        }

                        // Obtendo o input para a edição
                        const input = jQuery(td).find('input');
                        const inputElement = input[0] as any;

                        // Adicionando um numeric mask ao input para formatar o peso digitado
                        const inputMask = new Inputmask({
                                alias: 'decimal',
                                numericInput: true,
                                unmaskAsNumber: true,
                                digits: 2,
                                groupSeparator: '.',
                                radixPoint: ',',
                                allowMinus: false,
                                placeholder: '',
                                showMaskOnFocus: false,
                                showMaskOnHover: false,
                                undoOnEscape: false
                        }).mask(inputElement);
                        // Setando o valor unitário projetado no input
                        inputElement.value = (entity?.pesoProjetadoValorUnitario !== undefined && entity?.pesoProjetadoValorUnitario !== null) ? entity?.pesoProjetadoValorUnitario : '';

                        // Ao realizar alterações no input
                        input.on('change', function() {
                            // Obtendo o valor unitário projetado no input
                            const unmaskedvalue = inputMask?.unmaskedvalue();
                            // Setando o valor unitário projetado
                            entity.pesoProjetadoValorUnitario = (!unmaskedvalue || unmaskedvalue === '') ? null : Number(unmaskedvalue);
                            // Calculando o valor projetado
                            const valorProjetado = calcularValorProjetado(entity.pesoProjetado, entity.pesoProjetadoValorUnitario);
                            // Atualizando o valor projetado
                            myself.changeValorProjetado(entity, valorProjetado, td);
                            // Atualizando a projeção no server
                            myself.saveProjecao(entity, td);
                        }).on('focus', () => {
                            jQuery(`#${this.idDataTable}`).find('tbody tr').removeClass('active');
                            jQuery(td)?.parent()?.addClass('active');
                        });
                    }
                },
                // Peso Projetado
                {
                    data: null,
                    className: 'col-peso col-peso-projetado text-right',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.PesoProjetado,
                    render: (data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        let template = '';
                        if (this.canSaveProjecaoPeso(data)) {
                            template +=  `<input type="text" class="form-control text-right" id="${this.createIdInputPesoProjetado(data.idAnaliseClassificacao)}">`
                        } else if (this.isLancamentoPeso(data.lancamentoAnaliseClassificacao)) {
                            template += `
                                <span class="container-value">
                                    ${this.decimalFormatPipe.transform(data?.pesoProjetado ? data?.pesoProjetado : null, 1, 0, 0)}
                                </span>
                            `;
                        }

                        return template;
                    },
                    createdCell: (td, entity: ClienteAnaliseMercadoClassificacaoSearch) => {
                        const myself = this;

                        // Somente cria o input de edição quando puder salvar a projeção por peso
                        if (!this.canSaveProjecaoPeso(entity)) {
                            return;
                        }

                        // Obtendo o input para a edição
                        const input = jQuery(td).find('input');
                        const inputElement = input[0] as any;

                        // Adicionando um numeric mask ao input para formatar o peso digitado
                        const inputMask = new Inputmask({
                                alias: 'decimal',
                                numericInput: true,
                                unmaskAsNumber: true,
                                digits: 0,
                                groupSeparator: '.',
                                radixPoint: ',',
                                allowMinus: false,
                                placeholder: '',
                                showMaskOnFocus: false,
                                showMaskOnHover: false,
                                undoOnEscape: false
                        }).mask(inputElement);
                        // Setando o valor projetado no input
                        inputElement.value = (entity?.pesoProjetado !== undefined && entity?.pesoProjetado !== null) ? entity?.pesoProjetado : '';

                        // Ao realizar alterações no input
                        input.on('change', function() {
                            // Obtendo o peso projetado no input
                            const unmaskedvalue = inputMask?.unmaskedvalue();
                            const pesoProjetado = (!unmaskedvalue || unmaskedvalue === '') ? null : Number(unmaskedvalue);
                            // Atualizando o peso projetado
                            myself.changePesoProjetado(entity, pesoProjetado, td);
                            // Atualizando a projeção no server
                            myself.saveProjecao(entity, td);
                        }).on('focus', () => {
                            jQuery(`#${this.idDataTable}`).find('tbody tr').removeClass('active');
                            jQuery(td)?.parent()?.addClass('active');
                        });

                        // Progress
                        /*if (this.configAnaliseMercado?.solicitarPotencial) {
                            entity.pesoProjetadoPercProgress = this.createTablePercProgress(entity?.pesoProjetadoPerc, td);
                        }*/
                    }
                },
                // Peso Realizado
                {
                    data: null,
                    className: 'col-peso col-peso-realizado text-right',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.PesoRealizado,
                    /*createdCell: (td: any, cellData: any, entity: ClienteAnaliseMercadoClassificacaoSearch) => {
                        // Progress
                        if (this.isLancamentoPeso(entity.lancamentoAnaliseClassificacao)) {
                            entity.pesoRealizadoPercProjetadoProgress = this.createTablePercProgress(entity.pesoRealizadoPercProjetado, td);
                        }
                    },*/
                    render: (data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        if (!data) {
                            return;
                        }

                        return `
                            <span class="container-value">
                                ${this.decimalFormatPipe.transform(data.pesoRealizado, 1, 0, 0)}
                            </span>
                        `;
                    }
                },


                /** Valor */
                // Valor Pretendido
                {
                    data: 'valorPretendido',
                    className: 'col-valor col-valor-pretendido text-right',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.ValorPretendido,
                    render: (data: number) => this.decimalFormatPipe.transform(data, 1, 0, 0)
                },
                // Valor Projetado
                {
                    data: null,
                    className: 'col-valor col-valor-projetado text-right',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.ValorProjetado,
                    render: (data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        let template = '';
                        if (this.canSaveProjecaoValor(data)) {
                            template += `<input type="text" class="form-control text-right" id="${this.createIdInputValorProjetado(data.idAnaliseClassificacao)}">`
                        } else {
                            template += `
                                <span class="container-value">
                                    ${this.decimalFormatPipe.transform(data?.valorProjetado ? data?.valorProjetado : null, 1, 0, 0)}
                                </span>
                            `;
                        }

                        return template;
                    },
                    createdCell: (td, entity: ClienteAnaliseMercadoClassificacaoSearch) => {
                        const myself = this;

                        // Somente cria o input de edição quando puder salvar a projeção por valor
                        if (!this.canSaveProjecaoValor(entity)) {
                            return;
                        }

                        // Obtendo o input para a edição
                        const input = jQuery(td).find('input');
                        const inputElement = input[0] as any;

                        // Adicionando um numeric mask ao input para formatar o valor digitado
                        const inputMask = new Inputmask({
                                alias: 'decimal',
                                numericInput: true,
                                unmaskAsNumber: true,
                                digits: 0,
                                groupSeparator: '.',
                                radixPoint: ',',
                                allowMinus: false,
                                placeholder: '',
                                showMaskOnFocus: false,
                                showMaskOnHover: false,
                                undoOnEscape: false
                        }).mask(inputElement);
                        // Setando o valor projetado no input
                        inputElement.value = (entity?.valorProjetado !== undefined && entity?.valorProjetado !== null) ? entity?.valorProjetado : '';

                        // Ao realizar alterações no input
                        input.on('change', function() {
                            // Otendo o valor projetado no input
                            const unmaskedvalue = inputMask?.unmaskedvalue();
                            const valorProjetado = (!unmaskedvalue || unmaskedvalue === '') ? null : Number(unmaskedvalue);
                            // Atualizando o valor projetado
                            myself.changeValorProjetado(entity, valorProjetado, td);

                            // Atualizando valor projetado no server
                            myself.saveProjecao(entity, td);
                        }).on('focus', () => {
                            jQuery(`#${this.idDataTable}`).find('tbody tr').removeClass('active');
                            jQuery(td)?.parent()?.addClass('active');
                        });

                        // Progress
                        /*if (this.configAnaliseMercado?.solicitarPotencial) {
                            entity.valorProjetadoPercProgress = this.createTablePercProgress(entity?.valorProjetadoPerc, td);
                        }*/
                    }
                },
                // Valor Realizado
                {
                    data: null,
                    className: 'col-valor col-valor-realizado text-right',
                    serverOrderByColumn: ClienteAnaliseMercadoClassificacaoSearchOrderBy.ValorRealizado,
                    /*createdCell: (td: any, cellData: any, entity: ClienteAnaliseMercadoClassificacaoSearch) => {
                        entity.valorRealizadoPercProjetadoProgress = this.createTablePercProgress(entity.valorRealizadoPercProjetado, td)
                    },*/
                    render: (data: ClienteAnaliseMercadoClassificacaoSearch) => {
                        if (!data) {
                            return;
                        }
                        return `
                            <span class="container-value">
                                ${this.decimalFormatPipe.transform(data.valorRealizado, 1, 0, 0)}
                            </span>
                        `;
                    }
                }
            ];

            const columnDefs: any[] = [
                {orderable: false, targets: [0]}
            ];
            // Ocultar representante
            if (this.isRepresentante) {
                columnDefs.push({visible:  false, targets: 2})
            }
            // Ocultar classificação
            if (this.isPerspectivaMeta) {
                columnDefs.push({visible:  false, targets: 3})
            }
            // Ocultar quantidade
            if (!this.controleQuantidade) {
                columnDefs.push({visible:  false, targets: [4, 5, 6, 7]})
            }
            // Ocultar peso
            if (!this.controlePeso) {
                columnDefs.push({visible:  false, targets: [8, 9, 10, 11]})
            }
            // Ocultar valor
            if (!this.controleValor) {
                columnDefs.push({visible:  false, targets: [12, 13, 14]})
            }
            // Ocultar preço médio (valor unitário)
            if (!this.isShowPrecoMedio()) {
                columnDefs.push({visible:  false, targets: [5, 9]})
            }

            this.dataTablesService.showTable(`#${this.idDataTable}`, this.dataTable, {
                columnDefs,
                columns,
                order: initOrder ? initOrder : [[1, 'asc']], // nome fantasia cliente asc
                searching: false,
                info: false,
                serverSide: true,
                processing: true,
                deferRender: true,
                scroller: true,
                scrollX: true,
                createdRow: (row: any, data: ClienteAnaliseMercadoClassificacaoSearch) => {
                    // Adicionando class css nos rows da tabel
                    if (data) {
                        if (this.canSaveProjecaoQuantidade(data)) { // Quantidade
                            jQuery(row).addClass('lancamento-quantidade');
                        } else if (this.canSaveProjecaoPeso(data)) { // Peso
                            jQuery(row).addClass('lancamento-peso');
                        } else if (this.canSaveProjecaoValor(data)) { // Valor
                            jQuery(row).addClass('lancamento-valor');
                        }
                    }
                },
                // stateSave: true,
                ajax: (data, callback, settings) => {
                    // Offset e Limit
                    const offset = data.start;
                    const limit = data.length;
                    // Order By
                    const order = data?.order[0];
                    const orderColumn = columns[order?.column];
                    const orderBy = (orderColumn?.serverOrderByColumn instanceof Function) ? orderColumn?.serverOrderByColumn() : orderColumn?.serverOrderByColumn;
                    const orderByDir = order?.dir;

                    this.clienteAnaliseMercadoClassificacaoHttpService.search(this.filter, orderBy, orderByDir, limit, offset)
                        .subscribe(
                            entities => {
                                callback({recordsTotal: this.total?.quantidadeRegistros, recordsFiltered: this.total?.quantidadeRegistros, data: entities});
                            },
                            (error: ApiError) => {
                                this.messageService.error(error.message, 'Erro ao pesquisar os clientes', error);
                                callback({recordsTotal: 0, recordsFiltered: 0, data: []});
                            }
                        );
                }
            }).then(dataTable => {
                this.dataTable = dataTable;
                this.dataTable
                    .on('preDraw', () => { // Antes de redesenhar a table
                        this.clearStatusProjetadoBadgePillContainer();
                        this.clearTablePercProgressContainer();
                    });

                setTimeout(() => {
                    // Adicionando evento handler no scroll do body da datatable
                    jQuery(this.el.nativeElement).find('.dataTables_scrollBody').on('scroll', () => {
                        this.visualizacaoStorageService.set(null, null, this.dataTable?.page?.info()?.page, this.dataTable?.order(), this.dataTable?.scroller?.page()?.start, this.visualizacaoStorageKey);
                    });

                    resolve();
                }, 500);
            })
            .catch(() => {});
        });
    }

    /** Verifica se o lançamento da análise é por quantidade */
    isLancamentoQuantidade(lancamento: number): boolean {
        // Lançamento da Análise
        if (lancamento) {
            return isLancamentoQuantidade(lancamento);
        }
        // Meta
        if (this.isPerspectivaMeta) {
            return isLancamentoQuantidade(this.meta?.lancamento ?? -1);
        }
        // Grupo de Classificação
        if (this.grupoClassificacao) {
            return isLancamentoQuantidade(this.grupoClassificacao.lancamento);
        }
        return false;
    }

    /** Verifica se o lançamento da análise é por peso */
    isLancamentoPeso(lancamento: number): boolean {
        // Lançamento da Análise
        if (lancamento) {
            return isLancamentoPeso(lancamento);
        }
        // Meta
        if (this.isPerspectivaMeta) {
            return isLancamentoPeso(this.meta?.lancamento ?? -1);
        }
        // Grupo de Classificação
        if (this.grupoClassificacao) {
            return isLancamentoPeso(this.grupoClassificacao.lancamento);
        }
        return false;
    }

    /** Verifica se o lançamento da análise é por valor */
    isLancamentoValor(lancamento: number): boolean {
        // Lançamento da Análise
        if (lancamento) {
            return isLancamentoValor(lancamento);
        }
        // Meta
        if (this.isPerspectivaMeta) {
            return isLancamentoValor(this.meta?.lancamento ?? -1);
        }
        // Grupo de Classificação
        if (this.grupoClassificacao) {
            return isLancamentoValor(this.grupoClassificacao.lancamento);
        }
        return false;
    }

    /** Se deve exibir o preço médio */
    private isShowPrecoMedio(): boolean {
        // Perspectiva Meta
        if (this.isPerspectivaMeta) {
            return this.meta?.solicitarPrecoMedio ?? false;
        }
        // Grupo de Classificação
        if (this.grupoClassificacao) {
            return this.grupoClassificacao.solicitarPrecoMedio;
        }

        return false;
    }

    /** Verifica se deve solicitar o preço médio nas análises de mercados */
    private solicitarPrecoMedio(entity: ClienteAnaliseMercadoClassificacaoSearch): boolean {
        // Lançamento da Análise
        if (entity?.solicitarPrecoMedioAnaliseClassificacao) {
            return entity.solicitarPrecoMedioAnaliseClassificacao;
        }
        // Meta
        if (this.isPerspectivaMeta) {
            return this.meta?.solicitarPrecoMedio ?? false;
        }
        // Grupo de Classificação
        if (this.grupoClassificacao) {
            return this.grupoClassificacao.solicitarPrecoMedio;
        }
        return false;
    }

    /** Verifica se deve solicitar o preço médio da quantidade nas análises de mercados */
    private solicitarPrecoMedioQuantidade(entity: ClienteAnaliseMercadoClassificacaoSearch): boolean {
        // Somente se puder salvar a projeção da quantidade e solicitar que seja informado o preço médio na quantidade
        return this.canSaveProjecaoQuantidade(entity) && this.solicitarPrecoMedio(entity);
    }

    /** Verifica se deve solicitar o preço médio do peso nas análises de mercados */
    private solicitarPrecoMedioPeso(entity: ClienteAnaliseMercadoClassificacaoSearch): boolean {
        // Somente se puder salvar a projeção do peso e solicitar que seja informado o preço médio no peso
        return this.canSaveProjecaoPeso(entity) && this.solicitarPrecoMedio(entity);
    }

    /** Cria e retorna o template das opções do lançamento */
    private createDropdownOptions(entity: ClienteAnaliseMercadoClassificacaoSearch): string {
        if (!entity) {
            return null;
        }

        const options = new ClienteAnaliseMercadoOptions();
        /** Análise */
        // Abrir análise de mercado do cliente
        options.canOpenAnaliseMercado = true;
        // Excluir lançamento classificação
        options.canDeleteLancamentoClassificacao = this.clienteAnaliseMercadoClassificacaoAuthGuardService.canDeleteLancamento(entity.idAnaliseClassificacao);

        /** Cliente */
        // Abrir cadastro do cliente
        options.canOpenCliente = true;
        // Pré-baixar cliente
        options.canPreBaixarCliente = this.clienteAuthGuardService.canPreBaixar(entity.cadastro);
        // Baixar cliente
        options.canBaixarCliente = this.clienteAuthGuardService.canBaixar(entity.cadastro, entity.situacao, this.isAdministrador, this.isAtendente, this.isFinanceiro);

        /** Central de Compras */
        /** Inserir uma nova central de compras */
        options.canInsertCentralCompra = true;
        // Editar central de compras
        options.canEditCentralCompra = this.clienteCentralCompraAuthGuardService.canEdit(entity.tipoPessoa);
        // Inserir participante em uma central de compras
        options.canInsertParticipanteCentralCompra = this.clienteCentralCompraAuthGuardService.canInsertParticipante(entity.tipoPessoa, entity.idClienteCentralCompra);

        let template = '';
        let countOptions = 0;
        if (options.hasAnyOption()) {
            template += `
            <span class="btn-group dropup table-options">
                    <button type="button" title="Opções" class="btn btn-link btn-options dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" tabindex="-1">
                        <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                <div class="dropdown-menu">
            `;

            /** Análise */
            if (options.hasOptionsAnalise()) {
                if (countOptions > 0) {
                    template += `
                        <div class="dropdown-divider"></div>
                    `;
                }
                template += `
                    <h6 class="dropdown-header">Análise de Mercado</h6>
                `;
                // Abrir análise do cliente
                if (options.canOpenAnaliseMercado) {
                    template += `
                        <a class="dropdown-item" id="openAnaliseMercado">
                            Abrir Análise
                        </a>
                    `;
                    countOptions++;
                }
                // Excluir lançamento classificação
                if (options.canDeleteLancamentoClassificacao) {
                    template += `
                        <a class="dropdown-item dropdown-item-delete" id="deleteLancamentoClassificacao">
                            Excluir Análise
                        </a>
                    `;
                    countOptions++;
                }
            }

            /** Cliente */
            if (options.hasOptionsCliente()) {
                if (countOptions > 0) {
                    template += `
                        <div class="dropdown-divider"></div>
                    `;
                }
                template += `
                    <h6 class="dropdown-header">Cliente</h6>
                `;
                // Abrir cadastro do cliente
                if (options.canOpenCliente) {
                    template += `
                        <a class="dropdown-item" id="openCliente">
                            Abrir Cadastro
                        </a>
                    `;
                    countOptions++;
                }
                // Pré-baixar cliente
                if (options.canPreBaixarCliente) {
                    template += `
                        <a class="dropdown-item dropdown-item-prebaixar" id="preBaixarCliente">
                            Pré-Baixar Cliente
                        </a>
                    `;
                    countOptions++;
                }
                // Baixar cliente
                if (options.canBaixarCliente) {
                    template += `
                        <a class="dropdown-item dropdown-item-baixar" id="baixarCliente">
                            Baixar Cliente
                        </a>
                    `;
                    countOptions++;
                }
            }

            /** Central de Compras */
            if (options.hasOptionsCentralCompra()) {
                if (countOptions > 0) {
                    template += `
                        <div class="dropdown-divider"></div>
                    `;
                }
                template += `
                    <h6 class="dropdown-header">Central de Compras</h6>
                `;
                // Inserir nova central de compras
                if (options.canInsertCentralCompra) {
                    template += `
                        <a class="dropdown-item" id="insertCentralCompra">
                            Adicionar Central de Compras
                        </a>
                    `;
                    countOptions++;
                }
                // Editar central de compras
                if (options.canEditCentralCompra) {
                    template += `
                        <a class="dropdown-item" id="editCentralCompra">
                            Atualizar Central de Compras
                        </a>
                    `;
                    countOptions++;
                }
                // Inserir participante em uma central de compras
                if (options.canInsertParticipanteCentralCompra) {
                    template += `
                        <a class="dropdown-item" id="insertParticipanteCentralCompra">
                            Adicionar como Participante
                        </a>
                    `;
                    countOptions++;
                }
            }

            template += `
                </div>
            </span>
            `;
        }

        return template;
    }

    /** Vincula os eventos ao dropdown das opções do lançamento */
    private bindEventsDropdownOptions(entity: ClienteAnaliseMercadoClassificacaoSearch, td: any) {
        const myself = this;

        const dropdown = jQuery(td)?.parent()?.find('.col-options .btn-group');
        // Ao abrir o dropdown, adicionamos ele no body para exibi-lo corretamente na table
        dropdown.on('show.bs.dropdown', function() {
            jQuery('body').append(dropdown.css({
                    position: 'absolute',
                    left: dropdown.offset().left,
                    top: dropdown.offset().top
                }).detach());
        });
        // Ao fechar o dropdown, adicionamos ele novamente a coluna das opções na table
        dropdown.on('hidden.bs.dropdown', function() {
            jQuery(td)?.parent()?.find('.col-options').append(dropdown.css({
                position: 'relative',
                left: 'auto',
                top: 'auto'
            }).detach());
        });
        // Opções do dropdown
        dropdown.on('click', 'a', function() {
            if (this.id === 'openCliente') {
                myself.openCliente(entity);
            } else if (this.id === 'openAnaliseMercado') {
                myself.openAnaliseMercado(entity);
            } else if (this.id === 'deleteLancamentoClassificacao') {
                myself.deleteLancamentoClassificacao(entity);
            } else if (this.id === 'insertCentralCompra') {
                myself.insertCentralCompra();
            } else if (this.id === 'editCentralCompra') {
                myself.editCentralCompra(entity);
            } else if (this.id === 'insertParticipanteCentralCompra') {
                myself.insertParticipanteCentralCompra(entity);
            } else if (this.id === 'preBaixarCliente') {
                myself.preBaixarCliente(entity);
            } else if (this.id === 'baixarCliente') {
                myself.baixarCliente(entity);
            }
        });
    }

    /** Seta e atualiza as opções do lançamento na col da table */
    private setColOptions(entity: ClienteAnaliseMercadoClassificacaoSearch, td: any) {
        // Atualizando o DOM com as novas opções do lançamento
        jQuery(td)?.parent()?.find('.col-options')?.html(this.createDropdownOptions(entity));
    }

    /** Cria o badge do status e insere na table cell informada
     *
     * @param td table cell onde será inserido o badge
     * @param entity lançamento da análise de mercado
     */
    private createStatusProjetadoBadgePill(td: any, entity: ClienteAnaliseMercadoClassificacaoSearch) {
        // Criando o badge pill do status
        const badgePillFactory = this.componentFactoryResolver.resolveComponentFactory(ClienteAnaliseMercadoStatusProjetadoBadgePillComponent);
        const badgePillRef = this.statusProjetadoBadgePillContainer.createComponent(badgePillFactory);
        badgePillRef.instance.statusProjetado = entity?.statusProjetado;
        // Inserindo o badge na table cell
        this.renderer.appendChild(td, badgePillRef.location.nativeElement);
    }

    /** Cria o ID do input do valor unitário projetado para a quantidade projetada */
    private createIdInputQuantidadeValorUnitarioProjetado(idClienteAnaliseMercadoClassificacao: number): string {
        return `quantidadeValorUnitarioProjetado_${idClienteAnaliseMercadoClassificacao}`;
    }

    /** Cria o ID do input da quantidade projetada */
    private createIdInputQuantidadeProjetada(idClienteAnaliseMercadoClassificacao: number): string {
        return `quantidadeProjetada_${idClienteAnaliseMercadoClassificacao}`;
    }

    /** Cria o ID do input do valor unitário projetado para o peso projetado */
    private createIdInputPesoValorUnitarioProjetado(idClienteAnaliseMercadoClassificacao: number): string {
        return `pesoValorUnitarioProjetado_${idClienteAnaliseMercadoClassificacao}`;
    }

    /** Cria o ID do input do peso projetado */
    private createIdInputPesoProjetado(idClienteAnaliseMercadoClassificacao: number): string {
        return `pesoProjetado_${idClienteAnaliseMercadoClassificacao}`;
    }

    /** Cria o ID do input do valor projetado */
    private createIdInputValorProjetado(idClienteAnaliseMercadoClassificacao: number): string {
        return `valorProjetado_${idClienteAnaliseMercadoClassificacao}`;
    }

    /** Cria a barra de progresso para exibir na tabela  */
    private createTablePercProgress(perc: number, td: any): TablePercProgressComponent {
        // Criando o progress
        const percProgressFactory = this.componentFactoryResolver.resolveComponentFactory(TablePercProgressComponent);
        const percProgressRef = this.tablePercProgressContainer.createComponent(percProgressFactory);
        percProgressRef.instance.perc = perc;
        // Inserindo o badge na table cell
        this.renderer.appendChild(td, percProgressRef.location.nativeElement);

        return percProgressRef.instance;
    }

    /** Ao alterar a quantidade projetada */
    private changeQuantidadeProjetada(entity: ClienteAnaliseMercadoClassificacaoSearch, quantidadeProjetada: number, td: any) {
        // Setando a quantidade projetada
        entity.quantidadeProjetada = quantidadeProjetada;
        // Calculando o percentual de participação da quantidade projetada sobre a quantidade potencial
        entity.quantidadeProjetadaPerc = calcularQuantidadeProjetadaPerc(entity.quantidadeProjetada, entity.quantidadePotencial);
        this.setColQuantidadeProjetada(entity, td);

        // Calculando o percentual da quantidade realizada sobre a quantidade projetada
        entity.quantidadeRealizadaPercProjetada = calcularQuantidadeRealizadaPerc(entity.quantidadeRealizada, entity.quantidadeProjetada);
        this.setColQuantidadeRealizada(entity, td);

        // Calculando o valor projetado
        const valorProjetado = calcularValorProjetado(entity.quantidadeProjetada, entity.quantidadeProjetadaValorUnitario);
        // Atualizando o valor projetado
        this.changeValorProjetado(entity, valorProjetado, td);
    }

    /** Seta e atualiza a quantidade projetada na col da table */
    private setColQuantidadeProjetada(entity: ClienteAnaliseMercadoClassificacaoSearch, td: any) {
        // Atualizando o DOM com a quantidade projetada
        jQuery(td)?.parent()?.find('.col-quantidade-projetada .container-value')?.html(this.decimalFormatPipe.transform(entity.quantidadeProjetada, 1, 0, 0));
        // Atualizando o progress com o percentual de participação da quantidade projetada
        if (entity.quantidadeProjetadaPercProgress) {
            entity.quantidadeProjetadaPercProgress.perc = entity.quantidadeProjetadaPerc;
        }
    }

    /** Seta e atualiza a quantidade realizada na col da table */
    private setColQuantidadeRealizada(entity: ClienteAnaliseMercadoClassificacaoSearch, td: any) {
        // Atualizando o DOM com a quantidade realizada
        jQuery(td)?.parent()?.find('.col-quantidade-realizada .container-value')?.html(this.decimalFormatPipe.transform(entity.quantidadeRealizada, 1, 0, 0));
        // Atualizando o progress com o percentual da quantidade realizada
        if (entity.quantidadeRealizadaPercProjetadaProgress) {
            entity.quantidadeRealizadaPercProjetadaProgress.perc = entity.quantidadeRealizadaPercProjetada;
        }
    }

    /** Ao alterar o peso projetado */
    private changePesoProjetado(entity: ClienteAnaliseMercadoClassificacaoSearch, pesoProjetado: number, td: any) {
        // Setando o peso projetado
        entity.pesoProjetado = pesoProjetado;
        // Calculando o percentual de participação do peso projetado sobre o peso potencial
        entity.pesoProjetadoPerc = calcularPesoProjetadoPerc(entity.pesoProjetado, entity.pesoPotencial);
        this.setColPesoProjetado(entity, td);

        // Calculando o percentual do peso realizado sobre o peso projetado
        entity.pesoRealizadoPercProjetado = calcularPesoRealizadoPerc(entity.pesoRealizado, entity.pesoProjetado);
        this.setColPesoRealizado(entity, td);

        // Calculando o valor projetado
        const valorProjetado = calcularValorProjetado(entity.pesoProjetado, entity.pesoProjetadoValorUnitario);
        // Atualizando o valor projetado
        this.changeValorProjetado(entity, valorProjetado, td);
    }

    /** Seta e atualiza o peso projetado na col da table */
    private setColPesoProjetado(entity: ClienteAnaliseMercadoClassificacaoSearch, td: any) {
        // Atualizando o DOM com o peso projetado
        jQuery(td)?.parent()?.find('.col-peso-projetado .container-value')?.html(this.decimalFormatPipe.transform(entity.pesoProjetado, 1, 0, 0));
        // Atualizando o progress com o percentual de participação do peso projetado
        if (entity.pesoProjetadoPercProgress) {
            entity.pesoProjetadoPercProgress.perc = entity.pesoProjetadoPerc;
        }
    }

    /** Seta e atualiza o peso realizado na col da table */
    private setColPesoRealizado(entity: ClienteAnaliseMercadoClassificacaoSearch, td: any) {
        // Atualizando o DOM com o peso realizado
        jQuery(td)?.parent()?.find('.col-peso-realizado .container-value')?.html(this.decimalFormatPipe.transform(entity.pesoRealizado, 1, 0, 0));
        // Atualizando o progress com o percentual do peso realizado
        if (entity.pesoRealizadoPercProjetadoProgress) {
            entity.pesoRealizadoPercProjetadoProgress.perc = entity.pesoRealizadoPercProjetado;
        }
    }

    /** Ao alterar o valor projetado */
    private changeValorProjetado(entity: ClienteAnaliseMercadoClassificacaoSearch, valorProjetado: number, td: any) {
        // Setando o valor projetado
        entity.valorProjetado = valorProjetado;

        try {
            // Recalculando o percentual de participação do valor projetado
            entity.valorProjetadoPerc = calcularValorProjetadoPerc(entity.valorProjetado, entity.valorPotencial);
            this.setColValorProjetado(entity, td);

            // Recalculando o percentual do valor realizado
            entity.valorRealizadoPercProjetado = calcularValorRealizadoPerc(entity.valorRealizado, entity.valorProjetado);
            this.setColValorRealizado(entity, td);
        } catch (error) {
            console.error(error);
        }
    }

    /** Seta e atualiaza o valor projetado na col da table */
    private setColValorProjetado(entity: ClienteAnaliseMercadoClassificacaoSearch, td: any) {
        // Atualizando o DOM com o valor projetado
        jQuery(td)?.parent()?.find('.col-valor-projetado .container-value')?.html(this.decimalFormatPipe.transform(entity.valorProjetado, 1, 0, 0));
        // Atualizando o progress com o percentual de participação do valor projetado
        if (entity.valorProjetadoPercProgress) {
            entity.valorProjetadoPercProgress.perc = entity.valorProjetadoPerc;
        }
    }

    /** Seta e atualiza o valor realizado na col da table */
    private setColValorRealizado(entity: ClienteAnaliseMercadoClassificacaoSearch, td: any) {
        // Atualizando o DOM com o valor realizado
        jQuery(td)?.parent()?.find('.col-valor-realizado .container-value')?.html(this.decimalFormatPipe.transform(entity.valorRealizado, 1, 0, 0));
        // Atualizando o progress com o percentual do valor realizado
        if (entity.valorRealizadoPercProjetadoProgress) {
            entity.valorRealizadoPercProjetadoProgress.perc = entity.valorRealizadoPercProjetado;
        }
    }

    private setColStatus(entity: ClienteAnaliseMercadoClassificacaoSearch, td: any) {
        // Removendo o conteúdo atual da table cell do status projetado
        jQuery(td)?.parent()?.find('.col-status')?.html('');
        // Atualizando o badge do status do lançamento
        // this.createStatusProjetadoBadgePill(jQuery(td)?.parent()?.find('.col-status')?.[0], entity);
    }

    /** Verifica se pode salvar a projeção */
    private canSaveProjecao(entity: ClienteAnaliseMercadoClassificacaoSearch): boolean {
        // Se não for o mês atual então não pode salvar a projeção
        if (!this.isMesAtual || !entity) {
            return false;
        }

        // Se for pela perspectiva da meta pode salvar a projeção
        // if (this.isPerspectivaMeta) {
        //     return true;
        // }

        // Se for pela perspcetiva projetada, somente quando possuir o lançamento da classificação na análise de mercado
        // return Number(entity.idAnaliseClassificacao) > 0;
        return true;
    }

    /** Verifica se pode salvar a projeção quando o lançamento for por quantidade */
    private canSaveProjecaoQuantidade(entity: ClienteAnaliseMercadoClassificacaoSearch): boolean {
        return this.canSaveProjecao(entity) && this.isLancamentoQuantidade(entity.lancamentoAnaliseClassificacao);
    }

    /** Verifica se pode salvar a projeção quando o lançamento for por peso */
    private canSaveProjecaoPeso(entity: ClienteAnaliseMercadoClassificacaoSearch): boolean {
        return this.canSaveProjecao(entity) && this.isLancamentoPeso(entity.lancamentoAnaliseClassificacao);
    }

    /** Verifica se pode salvar a projeção quando o lançamento for por valor */
    private canSaveProjecaoValor(entity: ClienteAnaliseMercadoClassificacaoSearch): boolean {
        return this.canSaveProjecao(entity) && this.isLancamentoValor(entity.lancamentoAnaliseClassificacao);
    }

    /** Obtem o Grupo de Classificação para salvar a projeção */
    private getIDGrupClassificacaoToSaveProjetacao(entity: ClienteAnaliseMercadoClassificacaoSearch): number {
        // Grupo de Classificação do Lançamento da Análise de Mercado
        if (entity?.idGrupoClassificacao) {
            return entity.idGrupoClassificacao;
        }
        // Grupo de Classificação da Meta
        if (this.isPerspectivaMeta) {
            return this.meta?.idGrupoClassificacao ?? null;
        }
        // Grupo de Classificação selecionado
        if (this.grupoClassificacao) {
            return this.grupoClassificacao.id;
        }
        return null;
    }

    /** Obtem o Grupo de Classificação para salvar a projeção */
    private getClassificacoesSlugToSaveProjetacao(entity: ClienteAnaliseMercadoClassificacaoSearch): number[] {
        // Classificações Slug do Lançamento da Análise de Mercado
        if (entity?.classificacoesSlug) {
            return entity.classificacoesSlug;
        }
        // Classificações Slug da Meta
        if (this.isPerspectivaMeta) {
            return this.meta?.classificacoesSlug ?? null;
        }
        // Classificações Slug do Grupo de Classificação selecionado
        if (this.grupoClassificacao) {
            return this.grupoClassificacao.classificacoesSlug;
        }
        return null;
    }

    /** Salva a projeção de venda na análise de mercado do cliente */
    private saveProjecao(entity: ClienteAnaliseMercadoClassificacaoSearch, td: any) {
        if (!this.isMesAtual || !entity) {
            return;
        }

        // Projeção do lançamento da classificação
        const entitySaveClassificacao = new ClienteAnaliseMercadoProjecaoClassificacaoSave(
            (entity.idAnaliseClassificacao ?? null),
            this.getIDGrupClassificacaoToSaveProjetacao(entity),
            this.getClassificacoesSlugToSaveProjetacao(entity),
            entity.quantidadeProjetada,
            entity.pesoProjetado,
            entity.valorProjetado
        );

        // Projeção do lançamento mensal do cliente
        const entitySave = new ClienteAnaliseMercadoProjecaoSave(entity.id, entity.idCliente, this.filter.mes, this.filter.ano, [entitySaveClassificacao]);
        entitySave.loadClassificacoesAfterSave = true;
        entitySave.perspectivaAfterSave = this.isPerspectivaMeta ? perspectivaMeta.id : perspectivaProjetada.id;

        this.isSaved = false;
        this.isSaving = true;
        this.clienteAnaliseMercadoProjecaoHttpService.save(entitySave)
            .subscribe(
                entitySaveResponse => {
                    this.isSaving = false;
                    this.isSaved = true;
                    this.lastSaveAt = new Date();

                    try {
                        entity.id = entitySaveResponse.idClienteAnaliseMercado;

                        const projecaoClassificacao = entitySaveResponse?.classificacoes[0]?.projecao ?? null;
                        if (projecaoClassificacao) {
                            // Classificação
                            entity.idAnaliseClassificacao = projecaoClassificacao.idClienteAnaliseMercadoClassificacao;
                            entity.classificacoesNome = projecaoClassificacao.classificacoesNome;
                            // Status Projetado
                            entity.statusProjetado = projecaoClassificacao.statusProjetado;
                            entity.idEtapaNegociacaoProjecao = projecaoClassificacao.idEtapaNegociacaoProjecao;
                            entity.nomeEtapaNegociacaoProjecao = projecaoClassificacao.nomeEtapaNegociacaoProjecao;
                            entity.corEtapaNegociacaoProjecao = projecaoClassificacao.corEtapaNegociacaoProjecao;
                            this.setColStatus(entity, td);
                            // Projetado
                            // entity.quantidadeProjetada = projecaoClassificacao.quantidadeProjetada;
                            // entity.quantidadeProjetadaValorUnitario = projecaoClassificacao.quantidadeProjetadaValorUnitario;
                            // entity.pesoProjetado = projecaoClassificacao.pesoProjetado;
                            // entity.pesoProjetadoValorUnitario = projecaoClassificacao.pesoProjetadoValorUnitario;
                            // entity.valorProjetado = projecaoClassificacao.valorProjetado;
                            // Realizado
                            entity.quantidadeRealizada = projecaoClassificacao.quantidadeRealizada;
                            entity.quantidadeRealizadaPercProjetada = projecaoClassificacao.quantidadeRealizadaPercProjetada;
                            this.setColQuantidadeRealizada(entity, td);
                            entity.pesoRealizado = projecaoClassificacao.pesoRealizado;
                            entity.pesoRealizadoPercProjetado = projecaoClassificacao.pesoRealizadoPercProjetado;
                            this.setColPesoRealizado(entity, td);
                            entity.valorRealizado = projecaoClassificacao.valorRealizado;
                            entity.valorRealizadoPercProjetado = projecaoClassificacao.valorRealizadoPercProjetado;
                            this.setColValorRealizado(entity, td);

                            // Atualizando as opções do lançamento
                            this.setColOptions(entity, td);
                            this.bindEventsDropdownOptions(entity, td);
                        } else {
                            // Atualizando a pesquisa
                            this.refresh();
                        }
                    } catch (error) {
                        console.error('Erro ao setar os valores projetados no lançamento do segmento após salvar:', error);
                        // Atualizando a pesquisa
                        this.refresh();
                    }

                    // Atualiza os totais
                    this.getTotais()
                        .then(() => {})
                        .catch(() => {});
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao atualizar a projeção de venda', error);
                    this.isSaving = false;
                    this.isSaved = false;
                }
            );
    }

    /** Calcula os percentuais projetados sobre as metas dos representantes */
    private calcularMetaPercProjetados() {
        // Calcula o percentual da quantidade projetada sobre a quantidade da meta dos representantes
        this.quantidadeMetaRepresentantesPercProjetada = this.metaCalculoService.calcularQuantidadeRealizadaPerc(this.total?.quantidadeProjetada, this.metaTotais?.quantidadeRepresentantes);

        // Calcula o percentual do peso projetado sobre o peso da meta dos representantes
        this.pesoMetaRepresentantesPercProjetado = this.metaCalculoService.calcularPesoRealizadoPerc(this.total?.pesoProjetado, this.metaTotais?.pesoRepresentantes);

        // Calcula o percentual do valor projetado sobre o valor da meta dos representantes
        this.valorMetaRepresentantesPercProjetado = this.metaCalculoService.calcularValorRealizadoPerc(this.total?.valorProjetado, this.metaTotais?.valorRepresentantes);
    }

    /** Abre o modal do cadastro do cliente */
    openCliente(entity: ClienteAnaliseMercadoClassificacaoSearch) {
        this.clienteFormModal?.edit(entity?.idCliente);
    }

    /** Após editar o cliente */
    afterEditCliente() {
        this.refresh();
    }

    /** Abre a análise de mercado do cliente */
    openAnaliseMercado(entity: ClienteAnaliseMercadoClassificacaoSearch) {
        if (entity?.idAnaliseClassificacao > 0) { // Se possuir o ID do lançamento abrimos este lançamento
            this.lancamentoFormModal?.open(perspectivaClassificacao, entity?.idCliente, entity?.ano, entity?.idAnaliseClassificacao, null, null, false, true);
        } else if (this.isPerspectivaMeta && this.meta) { // Se não, se for a perspectiva de meta criamos o lançamento pela meta
            this.lancamentoFormModal?.open(perspectivaClassificacao, entity?.idCliente, entity?.ano, null, this.meta.idGrupoClassificacao, this.meta.classificacoesSlug, true, true);
        } else if (this.grupoClassificacao) { // Se não, abrimos pelo grupo
            this.lancamentoFormModal?.open(perspectivaClassificacao, entity?.idCliente, entity?.ano, null, this.grupoClassificacao.id, this.grupoClassificacao.classificacoesSlug, true, true);
        }
    }

    afterSaveLancamentoClassificacao() {
        this.refresh();
    }

    /** Exclui o lançamento da classificação na análise de mercado */
    deleteLancamentoClassificacao(entity: ClienteAnaliseMercadoClassificacaoSearch) {
        if (!entity || !this.clienteAnaliseMercadoClassificacaoAuthGuardService.canDeleteLancamento(entity.idAnaliseClassificacao)) {
            this.messageService.info(`Não é possível abrir o excluir a análise do segmento ${entity?.classificacoesNome} do cliente ${this.clienteNomePipe.transform(entity?.nomeCliente, entity?.nomeFantasiaCliente, entity?.codigoIntegracaoErpCliente, entity?.tipoPessoa)}`, 'Informação');
            return;
        }

        this.messageService.confirm(`Deseja realmente excluir a análise do segmento ${entity.classificacoesNome} do cliente ${this.clienteNomePipe.transform(entity.nomeCliente, entity.nomeFantasiaCliente, entity.codigoIntegracaoErpCliente, entity.tipoPessoa)}?`, 'Confirme').then((result) => {
            if (result) {
                this.clienteAnaliseMercadoLancamentoHttpService.deleteClassificacao(entity.idAnaliseClassificacao)
                    .subscribe(
                        () => {
                            this.messageService.success('', `Análise do segmento ${entity.classificacoesNome} do cliente ${this.clienteNomePipe.transform(entity.nomeCliente, entity.nomeFantasiaCliente, entity.codigoIntegracaoErpCliente, entity.tipoPessoa)} excluído com sucesso`);
                            this.refresh();
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.message, `Erro ao excluir a análise do segmento ${entity.classificacoesNome} do cliente ${this.clienteNomePipe.transform(entity.nomeCliente, entity.nomeFantasiaCliente, entity.codigoIntegracaoErpCliente, entity.tipoPessoa)}`);
                        }
                    );
            }
        });
    }

    /** Abre o modal para inserir uma compras no cliente */
    insertCentralCompra() {
        this.clienteFormModal?.insert(null, pessoaCentralCompras.id);
    }

    /** Abre o modal para atualizar a central de compras */
    editCentralCompra(entity: ClienteAnaliseMercadoClassificacaoSearch) {
        if (!entity) {
            return;
        }

        this.centralCompraFormModal?.edit(entity.idCliente);
    }

    /** Após salvar uma central de compras */
    afterSaveCentralCompra() {
        this.refresh();
    }

    /** Abre o modal para inserir um participante em uma compras no cliente */
    insertParticipanteCentralCompra(entity: ClienteAnaliseMercadoClassificacaoSearch) {
        if (!entity) {
            return;
        }

        const participante = new ClienteCentralCompraParticipante(entity.idCliente, entity.idPessoa, entity.codigoIntegracaoErpCliente, entity.cnpjCpfCliente, entity.nomeCliente, entity.nomeFantasiaCliente);
        this.centralCompraParticipanteFormModal?.insert(participante);
    }

    /** Abre o modal para pré-baixar o cliente */
    preBaixarCliente(entity: ClienteAnaliseMercadoClassificacaoSearch) {
        this.clienteCarteiraPreBaixarModal?.insert(entity?.idCliente);
    }

    /** Abre o modal para baixar o cliente */
    baixarCliente(entity: ClienteAnaliseMercadoClassificacaoSearch) {
        this.clienteCarteiraBaixarModal?.insert(entity?.idCliente, entity?.motivoBaixaCliente);
    }

    /** Destroi todos os badges criados dinamicamentes e adicionados na table */
    private clearStatusProjetadoBadgePillContainer() {
        this.statusProjetadoBadgePillContainer?.clear();
    }

    /** Destrou todos os perc progress criados dinamicamentes e adicionados na table */
    private clearTablePercProgressContainer() {
        this.tablePercProgressContainer?.clear();
    }

    ngOnDestroy() {
        this.clearStatusProjetadoBadgePillContainer();
        this.clearTablePercProgressContainer();
    }
}
